<template>
  <div class="app-container">
    <el-select
      filterable
      v-if="userInfo.is_super == 1"
      class="screenInput"
      v-model="screen.park_id"
      placeholder="请选择园区"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-input
    maxlength="11"
      class="screenInput"
      v-model="screen.like"
      placeholder="请输入手机号和姓名"
    ></el-input>
    <el-select
      filterable
      class="screenInput"
      v-model="screen.status"
      placeholder="请选择状态"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in statusList"
        :key="index"
      ></el-option>
    </el-select>
    <el-button type="primary" @click="(screen.page = 1), fetchData()"
      >筛选</el-button
    >
    <el-button type="primary" plain @click="chongZhi()">重置</el-button>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="apply_id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.park_name">
            {{ scope.row.park_name }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="业主姓名">
        <template slot-scope="scope">
          {{ scope.row.legal_name }}
        </template>
      </el-table-column>
      <el-table-column label="业主手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.legal_phone }}
        </template>
      </el-table-column> -->
      <el-table-column label="住户姓名">
        <template slot-scope="scope">
          {{ scope.row.resident_name }}
        </template>
      </el-table-column>
      <el-table-column label="住户手机号" align="center">
        <template slot-scope="scope">
          {{ scope.row.link_phone }}
        </template>
      </el-table-column>
      <el-table-column label="住宅名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.name">
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.create_time }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="租户类型" align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.role_name }} </span>
        </template>
      </el-table-column>

      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.status == '1'
                ? 'success'
                : scope.row.status == '0'
                ? 'info'
                : 'danger'
            "
            disable-transitions
            >{{
              scope.row.status == 1
                ? "审核通过"
                : scope.row.status == 0
                ? "待审核"
                : "审核拒绝"
            }}</el-tag
          >
        </template>
      </el-table-column>
      
      <el-table-column label="驳回原因" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.reason">
            {{ scope.row.reason }}
          </div>
        </template>
      </el-table-column>
      
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            v-if="roles.includes('/house_user/audit') && scope.row.status == 0"
            @click="examine(scope.row)"
            >审批</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="审批" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审批"
          prop="status"
          :rules="[
            { required: true, message: '请选择审批', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="reason" label="驳回原因" v-if="form.status == 2">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { openPark } from "@/api/index";
import { audit, examine_lists } from "@/api/house";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageOss"]),
  },
  data() {
    return {
      dialogVisible: false,
      token: getToken(),
      statusList: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "待审核",
          id: 0,
        },
        {
          name: "已拒绝",
          id: 2,
        },
      ],
      total: 0,
      list: [],
      listLoading: true,
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        like: "",
        park_id: "",
        status: "",
      },
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      companyList: [],
      form: {},
      rules: {
        system_role_id: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    if (this.userInfo.is_super != 1) {
      if (this.userInfo.type == 1) {
        this.screen.park_id = this.userInfo.park_id;
      } else if (this.userInfo.type == 2) {
        this.screen.park_id = this.userInfo.park_id;
      }
    }
    this.getPark();
    this.fetchData();
  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              audit(that.form).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 审批
    examine(val) {
    console.log(val)
      this.form = {
        apply_id: val.apply_id,
        status: "",
        reason: "",
      };
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        like: "",
        park_id: "",
        status: "",
      };
      if (this.userInfo.is_super != 1) {
        if (this.userInfo.type == 1) {
          this.screen.park_id = this.userInfo.park_id;
        } else if (this.userInfo.type == 2) {
          this.screen.park_id = this.userInfo.park_id;
        }
      }
      this.fetchData();
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    fetchData() {
      this.listLoading = true;
      examine_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
